import { configureStore } from "@reduxjs/toolkit";
import user from './Slices/user';
import authStates from './Slices/authStates';
import jobs from './Slices/jobs';
import industries from './Slices/industries';
import dashboard from './Slices/dashboard';
import disc from './Slices/disc';
import registrationStates from './Slices/registrationStates';
import mocks from './Slices/mocks';

const store = configureStore({
    reducer: {
        authStates,
        user,
        jobs,
        industries,
        dashboard,
        disc,
        registrationStates,
        mocks,
    }
});

export default store;